import { useSlate } from 'slate-react';
import { Fonts, IconButton } from "./RichTextEditor.toolbar";
import { getBlockOfType, isBlockActive, isMarkActive, toggleBlock, toggleLink, toggleMark } from "./RichTextEditor.utils";
import { LinkOutlineIcon } from '@applyboard/ui-icons';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export function FontsWrapper(_ref) {
  var headingsConfig = _ref.headingsConfig;
  var editor = useSlate();
  var blockNode = getBlockOfType(editor, 'heading');
  // @ts-expect-error depth is available on `heading` nodes
  var depth = blockNode === null || blockNode === void 0 ? void 0 : blockNode.depth;
  return _jsx(Fonts, {
    onClick: function onClick(variant) {
      toggleBlock(editor, variant === 'p' ? 'paragraph' : variant);
    },
    value: depth ? "h".concat(depth) : 'p',
    headingsConfig: headingsConfig
  });
}
export function LinkWrapper() {
  var editor = useSlate();
  return _jsx(BlockButton, {
    format: "link",
    icon: LinkOutlineIcon,
    label: "Toggle link",
    onClick: function onClick(e) {
      e.preventDefault();
      toggleLink(editor);
    }
  });
}
export function BlockButton(_ref2) {
  var format = _ref2.format,
    Icon = _ref2.icon,
    label = _ref2.label,
    _onClick = _ref2.onClick;
  var editor = useSlate();
  return _jsx(IconButton, {
    "aria-label": label,
    icon: Icon,
    isActive: isBlockActive(editor, format),
    onClick: function onClick(e) {
      return _onClick ? _onClick(e) : toggleBlock(editor, format);
    }
  });
}
export function MarkButton(_ref3) {
  var format = _ref3.format,
    Icon = _ref3.icon,
    label = _ref3.label;
  var editor = useSlate();
  return _jsx(IconButton, {
    "aria-label": label,
    icon: Icon,
    isActive: isMarkActive(editor, format),
    onClick: function onClick() {
      return toggleMark(editor, format);
    }
  });
}